import { VoidFunction } from "../../models/common.models";
import { useState, useEffect } from "react";
import { Box, Skeleton } from "@mui/material";

interface ImageProps {
  src: string;
  sx?: React.CSSProperties;
  onClick?: VoidFunction;
  hideSkeleton?: boolean;
}

const Image = ({ src, sx, onClick, hideSkeleton }: ImageProps) => {
  const [loading, setLoading] = useState(false);

  const handleLoad = () => {
    setLoading(false);
  };

  useEffect(() => {
    const img = new window.Image();
    img.style.objectFit = "cover";
    img.src = src;

    if (img.complete) {
      setLoading(false);
    } else {
      setLoading(true);
      img.onload = handleLoad;
    }

    return () => setLoading(true);
  }, [src]);

  return (
    <>
      <img
        onClick={onClick}
        style={{
          ...sx,
          objectFit: sx?.objectFit || "cover",
          opacity: sx?.opacity ? sx.opacity : loading ? 0 : 1,
          transition: "opacity 0.3s",
          position: loading ? "absolute" : "static",
        }}
        src={src}
        onLoad={handleLoad}
        alt="Image"
      />
      {loading && !hideSkeleton && (
        <Skeleton sx={{ ...sx, opacity: "0.2" }} variant="rectangular" />
      )}
      {hideSkeleton && loading && <Box sx={{ ...sx }}></Box>}
    </>
  );
};

export default Image;
